import { BillCategory } from '@fruitful/types';
import {
    BabyIcon,
    CircleDashedIcon,
    CreditCardIcon,
    HandCoinsIcon,
    HomeIcon,
    RepeatIcon,
    ShieldCheckIcon,
    ZapIcon,
} from 'lucide-react-native';

import type { IconType } from './Icon';

export const BillCategoryIcons: Record<BillCategory, IconType> = {
    [BillCategory.CHILDCARE]: BabyIcon,
    [BillCategory.CREDIT_CARD_MINIMUM]: CreditCardIcon,
    [BillCategory.INSURANCE]: ShieldCheckIcon,
    [BillCategory.LOANS]: HandCoinsIcon,
    [BillCategory.OTHER]: CircleDashedIcon,
    [BillCategory.SUBSCRIPTIONS]: RepeatIcon,
    [BillCategory.RENT_MORTGAGE]: HomeIcon,
    [BillCategory.UTILITIES]: ZapIcon,
};
